<template>
    <div class="prelative timeline-filters">
        <CompassTabs v-model="selectedTab" background="app" @update:modelValue="handleClick">
            <CompassTabPane
                v-for="(tab, key) in tabList"
                :key="key"
                :label="tab.label"
                :name="tab.value"
                :entity="tab.entity"
                :icon="showPinIcon(tab)"
                :badge="showTabBadge(tab)"
                :badgeColor="badgeColor(tab)"
                :dataBot="tab.databot"
            />
        </CompassTabs>
    </div>
</template>

<script>
import Feature from 'Services/Feature';

export default {
    props: {
        activeTab: {
            type: String,
            required: true,
            default: 'activity',
        },
        tabs: {
            type: Array,
            required: true,
        },
        counters: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    data() {
        return {
            newFilters: {
                entities: [],
                start: '',
                end: '',
                pinned: false,
            },
            selectedTab: this.activeTab,
        };
    },
    computed: {
        tabList() {
            let newTabList = this.tabs;

            if (!this.pinAllowed) {
                newTabList = newTabList.filter((tab) => tab.value !== 'pinned');
            }

            if (!this.marketingModuleAllowed) {
                newTabList = newTabList.filter((tab) => tab.value !== 'marketing');
            }

            return newTabList.filter((tab) => tab.entities?.length > 0);
        },
        /**
         * Only allowed if feature flag
         * @returns boolean
         */
        pinAllowed() {
            return Feature.isEnabled('timeline-activity-pinning');
        },
        marketingModuleAllowed() {
            return Feature.isEnabled('sendethic');
        },
    },
    methods: {
        showPinIcon(tab) {
            return tab.value === 'pinned' ? 'pin-fill' : '';
        },
        showTabBadge(tab) {
            if (this.counters[tab.value] && this.counters[tab.value].count > 0) {
                return parseInt(this.counters[tab.value].count);
            }
        },
        badgeColor(tab) {
            if (this.counters[tab.value] && this.counters[tab.value].count > 0) {
                return this.counters[tab.value].type === 'danger' ? 'warning' : 'default';
            }
        },
        isSelected(tab) {
            return this.selectedTab === tab.value;
        },
        getFlagValue: (value) => {
            return typeof value === 'number' ? value.toString() : value;
        },
        handleClick(tab) {
            const entities = this.tabList.find((oneTab) => oneTab.value === tab).entities;
            this.$emit('update:activeTab', this.selectedTab);
            this.setFilter(entities, tab);
        },
        setFilter(values, selectedTab) {
            this.newFilters.entities = [];
            this.newFilters.entities = values;
            this.newFilters.currentTab = selectedTab;
            this.newFilters.pinned = selectedTab === 'pinned';
            this.applyFilter();
        },
        applyFilter() {
            this.$emit('applyFilter', this.newFilters);
        },
    },
};
</script>

<style lang="scss" scoped>
.timeline-filters {
    :deep(.el-tabs__nav) {
        display: flex;
        .el-tabs__item {
            padding: 0 !important;
            margin-bottom: 8px;
        }
    }
    .timeline-filters-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 4px 8px;
        border-radius: 4px;
        color: var(--colors-component-text-navigation-default);
        &:hover {
            color: var(--colors-component-text-navigation-hover-alt);
            background-color: var(--colors-component-background-navigation-hover);
        }
        &--is-selected {
            background-color: var(--colors-component-background-navigation-active-default);
            color: var(--colors-component-text-navigation-active-default);
            &:hover {
                color: var(--colors-component-text-navigation-active-hover-alt);
                background-color: var(--colors-component-background-navigation-active-hover);
            }
        }
        &-flag__is-danger {
            background-color: var(--colors-component-text-tag-red);
        }
        .compass-flag {
            padding-left: 6px;
            padding-right: 6px;
        }
    }
    .timeline-content-filters {
        position: absolute;
        right: 0;
        z-index: 1;
    }
}
</style>
